export * from '../src/composites/wui-profile-button/index.js';
//# sourceMappingURL=wui-profile-button.js.map